module.exports = __webpack_public_path__ + "img/bgf 2024.51957c7a.webp";